import { createContext } from 'react';
import { SetSuppliertToIncidentInput } from '@/graphql/generated';

export type AddSupplierFormModalContextProps = {
  closeModal: () => void
  openModal: (supplierData?: SetSuppliertToIncidentInput) => void
  supplierData: SetSuppliertToIncidentInput | null
  isOpen: boolean
}

export const AddSupplierFormModalContext = createContext<AddSupplierFormModalContextProps | null>(null)